import script from "./risk.vue?vue&type=script&setup=true&lang=js"
export * from "./risk.vue?vue&type=script&setup=true&lang=js"

import "./risk.vue?vue&type=style&index=0&id=55818526&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55818526"]])

export default __exports__